import React from 'react';

export default function About() {
  return (
    <>
      <section className="container-wrapper">
    <h2>About Us</h2>
    <p>BridgingSkilled is a leading IT training and skill development company dedicated to delivering high-quality, practical, and industry-relevant learning experiences. We specialize in <strong>full-stack development, MERN stack, Java, databases, and modern web technologies</strong>.</p>
   <p>BridgingSkilled is a leading Education and Skill Development Services company committed to empowering individuals through high-quality learning and practical training.</p>
  <p>Our mission is to bridge the gap between learning and real-world performance by offering programs that are aligned with the latest industry demands. We believe in preparing students and professionals not just for jobs, but for careers with long-term growth.</p>
  <p>Whether you are a student, fresher, working professional, or a corporate team — we offer customized solutions to enhance your knowledge, build confidence, and unlock new opportunities.</p>

  <h2>Our Vision</h2>
    <p>To become a trusted global leader in IT education by <strong>bridging the gap between learning and real-world performance</strong>. We envision a future where every student, fresher, or working professional has access to <strong>affordable, high-quality, and practical training</strong> that leads to meaningful career growth.</p>
    <h2>Our Mission</h2>
    <p>To <strong>equip learners with in-demand technical skills</strong> through innovative and practical training programs.</p>
    <p>To <strong>connect skills with opportunities</strong> by aligning education with the latest industry trends.</p>
    <p>To <strong>empower students, professionals, and corporate teams</strong> with customized solutions that enhance knowledge, boost confidence, and unlock new career possibilities.</p>
  </section>
  </>
  );
}

